import { closeSM } from "@/components/icons/SVGIcons";
import { MONTH_STRING } from "@/lib/globalFormatterHelper";
import type { IqueryForExecutionSummaryHistorical } from "@/services/ActionSummaryTableSERVICES";
import historicalSearchStore, {
  returnHistoricalSearch,
} from "@/store/historicalSearchStore";
import { returnToLiveTrades } from "@/store/historicalSearchStoreACTIONS";
import WidgetHeaderSubtitle from "./WidgetHeaderSubtitle";

// LQC-1885 - names the date range beside the widget name while it shows historical trades.
export const HISTORICAL_SEARCH_COMPONENT_KEYS = ["ActionSummary", "TradeTile"];

export const HISTORICAL_SEARCH_LABEL = "Historical Search";

// "d Mon yyyy", year dropped from the start date when both share it.
export function returnHistoricalSearchRange(
  search: IqueryForExecutionSummaryHistorical,
): string {
  if (!search.shortStartDate || !search.shortEndDate) return "";

  const start = new Date(`${search.shortStartDate}T00:00`);
  const end = new Date(`${search.shortEndDate}T00:00`);
  const sameYear = start.getFullYear() == end.getFullYear();

  const startText = `${start.getDate()} ${MONTH_STRING[start.getMonth()]}${sameYear ? "" : ` ${start.getFullYear()}`}`;
  const endText = `${end.getDate()} ${MONTH_STRING[end.getMonth()]} ${end.getFullYear()}`;

  return `${startText} to ${endText}`;
}

const WidgetHeaderHistoricalSearch = ({ cryptoID }: { cryptoID: string }) => {
  const search = historicalSearchStore((state) =>
    returnHistoricalSearch(state.searchByCryptoId, cryptoID),
  );

  if (!search.viewingHistoricalTable) return null;

  const range = returnHistoricalSearchRange(search);

  return (
    <WidgetHeaderSubtitle
      testId={`WidgetHeaderHistoricalSearch-${cryptoID}`}
      title={
        range ? `${HISTORICAL_SEARCH_LABEL} ${range}` : HISTORICAL_SEARCH_LABEL
      }
    >
      <span className="truncate opacity-80">{HISTORICAL_SEARCH_LABEL}</span>
      <span className="flex min-w-0 items-center gap-1 rounded-full bg-black/20 pl-2 pr-1 text-[0.85em] leading-5 dark:bg-white/10">
        {range && <span className="truncate opacity-80">{range}</span>}
        {/* hide-button-fromDrag stops RGL treating the click as a drag. */}
        <button
          type="button"
          data-testid={`WidgetHeaderHistoricalSearchCloseButton-${cryptoID}`}
          id={`WidgetHeaderHistoricalSearchCloseButton-${cryptoID}`}
          title="Return to Live Trades"
          aria-label="Return to Live Trades"
          className="hide-button-fromDrag flex h-4 w-4 shrink-0 items-center justify-center rounded-full opacity-70 hover:cursor-pointer hover:bg-black/20 hover:opacity-100 dark:hover:bg-white/20"
          onClick={() => returnToLiveTrades(cryptoID)}
        >
          {closeSM}
        </button>
      </span>
    </WidgetHeaderSubtitle>
  );
};

export default WidgetHeaderHistoricalSearch;
